import React from 'react';
import { handleView } from '../handle_view';
import { CatalogDeliveryInfoLightBoxStore } from '../../_flux/stores/catalog_delivery_info_light_box_store';
import { LightBox } from '../../_flux/components/catalog_delivery_info_light_box/light_box';
import { hide } from '../../_flux/actions/catalog_delivery_info_light_box_actions';

const stores = {
    lightBox: CatalogDeliveryInfoLightBoxStore,
};

const render = ({ lightBox }, options) => (
    <LightBox
        visible={lightBox.visible}
        showFreeShipping={lightBox.showFreeShipping}
        onClose={hide}
        staticUrl={TYROOLA.globals.staticImagesUrl}
        baseUrl={options.baseUrl}
    />
);

export const init = (container, options) =>
    handleView(stores, render, options, container);
